<template>
  <div class="timeline-section__headline">
    <div class="timeline-section__title-container">
      <div
        v-if="sticky"
        class="timeline-section__sticky-title"
      >
        <timeline-title :settings="settings" />
      </div>

      <!-- Hidden but is placed here to take up space -->
      <timeline-title :settings="settings" />
    </div>

    <div
      class="timeline-section__blurb"
      v-html="settings.blurb"
    />
  </div>
</template>

<script>

/**
 * Vue: Timeline headline (timeline-headline)
 * -----------------------------------------------------------------------------
 * Reusable title and blurb markup for timeline section
 *
 */

import TimelineTitle from '~async/timeline-section/timeline-title'

export default {
  name: 'TimelineHeadline',

  components: {
    TimelineTitle,
  },

  props: {
    settings: {
      type: Object,
      default: () => ({
        hat: '',
        heading: '',
        hat_style: '',
        mobile_hat_style: '',
        heading_style: '',
        mobile_heading_style: '',
        blurb: '',
      }),
    },
    sticky: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
